import PartnerMetrics from "./modules/PartnerMetrics/index";
import Foundation from "./modules/Foundation";
import Marketing from "./modules/Marketing";
import PartnerGoals from "./modules/PartnerGoals";
import PartnerOpportunities from "./modules/PartnerOpportunities";
import CoSelling from "./modules/CoSelling";
import PartnerPlanning from "./modules/PartnerPlanning";
import SalesAndTechnicalEnablement from "./modules/SalesAndTechnicalEnablement";
import BusinessExpansion from "./modules/BusinessExpansion";

export default function createPDFTemplate(forms, year, partnerName) {
  // let selected = ["PartnerPlanning", "PartnerMetrics"];
  console.log("Started compiling PDF")
  var dd = {
    pageMargins: [20,90,20,90],
    header: {
      columns: [
        {
          image: "data:image/png;base64,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",
          width: 100,
          margin: [20,20]
        },
        {
          text: [
            year,
            ' AWS ',
            {text: partnerName, bold: true, italics: true},
            ' Plan-External',
          ],
          margin: [0, 30],
          fontSize: 13,
          alignment: "right"
        }
      ],
      fontSize: 10,
      margin: [20,20],
      opacity: 1
    }, //End header
    content: [
      {
        text: partnerName,
        style: "title",
        alignment: "center",
        bold: true
      },
      {
        text: "Partner Plan " + year,
        style: "subtitle"
      },
      forms.PartnerMetrics ? PartnerMetrics(forms.PartnerMetrics, year) : null,
      forms.BusinessExpansion ? BusinessExpansion(forms.BusinessExpansion) : null,
      forms.Foundation ? Foundation(forms.Foundation) : null,
      forms.Marketing ? Marketing(forms.Marketing) : null,
      forms.PartnerGoals ? PartnerGoals(forms.PartnerGoals) : null,
      forms.PartnerOpportunities ? PartnerOpportunities(forms.PartnerOpportunities, year) : null,
      forms.CoSelling ? CoSelling(forms.CoSelling) : null,
      forms.PartnerPlanning ? PartnerPlanning(forms.PartnerPlanning, year) : null,
      forms.SalesAndTechnicalEnablement ? SalesAndTechnicalEnablement(forms.SalesAndTechnicalEnablement, year) : null
    ],//End content
    footer: {
      text: "AWS CONFIDENTIAL – This document is for discussion purposes only and does not create a legally binding or enforceable agreement or offer and is not enforceable against either party.  Neither party will be liable to the other party as a result of the failure to fulfill any obligation described in this document or the failure to enter into any agreement contemplated by this document.",
      fontSize: 10,
      margin: [20,20],
      opacity: 1
    },
    styles: {
      title: {
        fontSize: 26,
        color: "#146eb4",
        alignment: "center",
        bold: true
      },
      subtitle: {
        fontSize: 20,
        alignment: "center",
        color: "#146eb4"
      },
      sectionHeader: {
        margin: [0, 10, 0, 0],
        fontSize: 18,
        bold: true,
        color: "#326094"
      },
      sectionBody: {
        fontSize: 12
      },
      sectionSortaSubheader: {
        margin: [0,5,0,0],
        fontSize: 16,
        bold: true,
        opacity: 0.95,
        color: "#326094"
      },
      sectionSubheader: {
        margin: [0,5,0,0],
        fontSize: 14,
        bold: true,
        opacity: 0.90,
        color: "#326094"
      },
      sectionSubsubheader: {
        margin: [0,5,0,0],
        fontSize: 13,
        bold: false,
        opacity: 0.85,
        color: "#326094"
      },
      quote: {
        italics: true
      },
      footer: {
        margin: [0, 10, 0, 0],
        fontSize: 20,
        bold: true,
        color: "#21437A"
      },
      small: {
        fontSize: 8
      }
    }
  };
  console.log("Finished compiling PDF!")
  return dd;
}
